var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAustralia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_32972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0028 12 0.00135937 12 0C18.6274 0 24 5.37262 24 12Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 0C11.9994 0 11.9987 4.6875e-05 11.998 4.6875e-05L12.0001 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9678 12H11.9999C11.9999 11.9891 11.9999 11.9787 11.9999 11.9679C11.9892 11.9786 11.9785 11.9893 11.9678 12Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.26092C12 4.14944 12 2.76583 12 6.10352e-05H11.998C5.3715 0.00113916 0 5.37325 0 12H6.26086V8.47445L9.78642 12H11.9679C11.9787 11.9893 11.9894 11.9786 12 11.9679C12 11.1595 12 10.4381 12 9.78653L8.47444 6.26092H12Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07124 1.56522C4.19441 2.63392 2.63413 4.1942 1.56543 6.07103V12H4.69588V4.69572V4.69567H12.0002C12.0002 3.70834 12.0002 2.76775 12.0002 1.56522H6.07124Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 10.5244L7.73641 6.26098H6.26074C6.26074 6.26093 6.26074 6.26098 6.26074 6.26098L11.9998 12H11.9998C11.9998 12 11.9998 10.9826 11.9998 10.5244Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23729 14.087L7.89588 15.4641L9.38309 15.1203L8.71709 16.4939L9.91305 17.4423L8.42398 17.7779L8.42815 19.3043L7.23729 18.3494L6.04648 19.3043L6.05065 17.7779L4.56152 17.4423L5.75754 16.4939L5.09145 15.1203L6.57874 15.4641L7.23729 14.087Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9668 16.6956L18.2961 17.3842L19.0397 17.2123L18.7066 17.8991L19.3047 18.3733L18.5601 18.5411L18.5622 19.3043L17.9668 18.8268L17.3714 19.3043L17.3734 18.5411L16.6289 18.3733L17.2269 17.8991L16.8939 17.2123L17.6375 17.3842L17.9668 16.6956Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9033 9.39133L15.2326 10.0799L15.9762 9.90798L15.6432 10.5947L16.2412 11.069L15.4967 11.2368L15.4987 12L14.9033 11.5225L14.3079 12L14.3099 11.2368L13.5654 11.069L14.1634 10.5947L13.8304 9.90798L14.574 10.0799L14.9033 9.39133Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9668 5.21738L18.2961 5.90597L19.0397 5.73408L18.7067 6.42085L19.3046 6.89503L18.5601 7.06289L18.5622 7.82611L17.9668 7.3486L17.3714 7.82611L17.3734 7.06289L16.6289 6.89503L17.2268 6.42085L16.8939 5.73408L17.6375 5.90597L17.9668 5.21738Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6426 8.34784L20.9718 9.03643L21.7155 8.8645L21.3825 9.55126L21.9805 10.0255L21.2359 10.1934L21.238 10.9565L20.6426 10.4791L20.0472 10.9565L20.0492 10.1934L19.3047 10.0255L19.9027 9.55126L19.5697 8.8645L20.3133 9.03643L20.6426 8.34784Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.729 12L18.988 12.7972H19.8262L19.1481 13.2899L19.4072 14.087L18.729 13.5943L18.0509 14.087L18.3099 13.2899L17.6318 12.7972H18.47L18.729 12Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_32972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/79691cb8.svg";
export { SvgAustralia as ReactComponent };